
define('text!modules/creatives/video/templates/list.html',[],function () { return '<div class="list-filters w-Filters no-entities clearfix"></div>\n<div class="list-body">\n\t<div class="video w-grid"></div>\n</div>\n';});

